module.exports = __webpack_public_path__ + "img/graph-zoom.774560f9.svg";